export const SLUG_API = 'brand_slug_detection';
export const BRANDING_API = 'brand_configuration';

// TODO: Data Protection - Implement data masking for sensitive booking information
// - Mask partial credit card numbers in booking details
// - Mask partial email addresses in booking history
// - Implement field-level encryption for PII data

// API Mapping Configuration - Maps generic API names to storeurl.mjs entries based on brand
export const API_MAPPING = {
  // SSO Email Verify APIs
  sso_email_verify: {
    'her': 'SSO Email Verify Frankfurt',
    'szg': 'SSO Email Verify Frankfurt', 
    'fmm': 'SSO Email Verify Frankfurt', 
    'lax': 'SSO Email Verify Virginia',
    'gso': 'SSO Email Verify Virginia',
    'pit': 'SSO Email Verify Virginia',
    'rsw': 'SSO Email Verify Virginia',
    'yhm': 'SSO Email Verify Virginia',
    'st1': 'SSO Email Verify Virginia',
    'hnl': 'SSO Email Verify Virginia',
    'ldy': 'SSO Email Verify London',
    'drw': 'SSO Email Verify London',
    'hvn': 'SSO Email Verify London',
    'inv': 'SSO Email Verify London',
    'ip1': 'SSO Email Verify London',
    'jer': 'SSO Email Verify London',
    'ml1': 'SSO Email Verify London',
    'noc': 'SSO Email Verify London',
    'nqy': 'SSO Email Verify London',
    'pb1': 'SSO Email Verify London',
    'sv1': 'SSO Email Verify London',
    'bhx': 'SSO Email Verify London',
    'sb2': 'SSO Email Verify London',
    'sb3': 'SSO Email Verify London',
    'sb4': 'SSO Email Verify London',
    'sb5': 'SSO Email Verify London',
    'bfs': 'SSO Email Verify London',
    'default': 'SSO Email Verify Main'
  },
  
  // SSO Email OTP Send APIs
  sso_email_otp_send: {
    'her': 'SSO Email OTP Send Frankfurt',
    'szg': 'SSO Email OTP Send Frankfurt',
    'fmm': 'SSO Email OTP Send Frankfurt',
    'lax': 'SSO Email OTP Send Virginia',
    'gso': 'SSO Email OTP Send Virginia', 
    'pit': 'SSO Email OTP Send Virginia',
    'rsw': 'SSO Email OTP Send Virginia',
    'yhm': 'SSO Email OTP Send Virginia',
    'st1': 'SSO Email OTP Send Virginia',
    'hnl': 'SSO Email OTP Send Virginia',
    'ldy': 'SSO Email OTP Send London',
    'drw': 'SSO Email OTP Send London',
    'hvn': 'SSO Email OTP Send London',
    'inv': 'SSO Email OTP Send London',
    'ip1': 'SSO Email OTP Send London',
    'jer': 'SSO Email OTP Send London',
    'ml1': 'SSO Email OTP Send London',
    'noc': 'SSO Email OTP Send London',
    'nqy': 'SSO Email OTP Send London',
    'pb1': 'SSO Email OTP Send London',
    'sv1': 'SSO Email OTP Send London',
    'bhx': 'SSO Email OTP Send London',
    'sb2': 'SSO Email OTP Send London',
    'sb3': 'SSO Email OTP Send London',
    'sb4': 'SSO Email OTP Send London',
    'sb5': 'SSO Email OTP Send London',
    'bfs': 'SSO Email OTP Send London',
    'default': 'SSO Email OTP Send Main'
  },
  
  // SSO Mobile OTP Send APIs
  sso_mobile_otp_send: {
    'lax': 'SSO Mobile OTP Send Virginia',
    'st1': 'SSO Mobile OTP Send Virginia',
    'hnl': 'SSO Mobile OTP Send Virginia',
    'pit': 'SSO Mobile OTP Send Virginia',
    'rsw': 'SSO Mobile OTP Send Virginia',
    'yhm': 'SSO Mobile OTP Send Virginia',
    'default': 'SSO Mobile OTP Send Virginia'
  },
  
  // SSO Auth Login APIs
  sso_auth_login: {
    'her': 'SSO Auth Login Frankfurt',
    'szg': 'SSO Auth Login Frankfurt',
    'fmm': 'SSO Auth Login Frankfurt',
    'lax': 'SSO Auth Login Virginia',
    'gso': 'SSO Auth Login Virginia',
    'pit': 'SSO Auth Login Virginia', 
    'rsw': 'SSO Auth Login Virginia',
    'yhm': 'SSO Auth Login Virginia',
    'st1': 'SSO Auth Login Virginia',
    'hnl': 'SSO Auth Login Virginia',
    'ldy': 'SSO Auth Login London',
    'drw': 'SSO Auth Login London',
    'hvn': 'SSO Auth Login London',
    'inv': 'SSO Auth Login London',
    'ip1': 'SSO Auth Login London',
    'jer': 'SSO Auth Login London',
    'ml1': 'SSO Auth Login London',
    'noc': 'SSO Auth Login London',
    'nqy': 'SSO Auth Login London',
    'pb1': 'SSO Auth Login London',
    'sv1': 'SSO Auth Login London',
    'bhx': 'SSO Auth Login London',
    'sb2': 'SSO Auth Login London',
    'sb3': 'SSO Auth Login London',
    'sb4': 'SSO Auth Login London',
    'sb5': 'SSO Auth Login London',
    'bfs': 'SSO Auth Login London',
    'default': 'SSO Auth Login Main'
  },
  
  // Customer Bookings APIs
  customer_bookings: {
    'her': 'Customer Bookings Frankfurt',
    'default': 'Customer Bookings Live'
  },
  
  customer_bookings_legacy: {
    'lax': 'Customer Bookings Legacy Virginia',
    'default': 'Customer Bookings Legacy Main'
  },

  customer_bookings_v5: 'Customer Bookings V5',
  
  customer_bookings_history: {
    'her': 'Customer Bookings History Frankfurt',
    'default': 'Customer Bookings History Main'
  },
  
  send_booking_email: {
    'her': 'Send Booking Email Frankfurt',
    'szg': 'Send Booking Email Frankfurt',
    'fmm': 'Send Booking Email Frankfurt',
    'lax': 'Send Booking Email Virginia',
    'default': 'Send Booking Email Main'
  },
  
  cancel_old_order: {
    'rdu': 'Cancel Old Order Virginia',
    'default': 'Cancel Old Order Main'
  },
  
  // Other APIs
  translation_api: 'Translation API',
  brand_slug_detection: 'Brand Slug Detection',
  brand_configuration: 'Brand Configuration',
  activity_log_dew: 'Activity Log DEW',
  activity_log_enw: 'Live Activity Log ENW',
  sso_user_details: 'SSO User Details',
  otp_preference_view: 'OTP Preference View'
};

// Get the correct API name from storeurl.mjs based on brand
export function getApiName(genericApiName, brandSlug) {
  const mapping = API_MAPPING[genericApiName];
  if (!mapping) {
    return genericApiName; // Return as-is if no mapping found
  }
  
  if (typeof mapping === 'string') {
    return mapping; // Direct mapping
  }
  
  // Brand-specific mapping
  const brandCode = brandSlug?.toLowerCase();
  return mapping[brandCode] || mapping.default || genericApiName;
}
